import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24 });

    return (
        <motion.div
            data-testid="scroll-progress-bar"
            className="fixed inset-x-0 top-0 z-[60] h-[2.5px] origin-left bg-gradient-to-r from-volt to-blue-500"
            style={{ scaleX }}
        />
    );
};
